import React from 'react';

import nakedNewsLogo from '../../assets/logo-naked-news.png';
import cam4Logo from '../../assets/logo-cam4.png';


const CoRegModal = (props) => (
  <div
    aria-hidden="false"
    className="modal nakednews-modal in"
    id="coreg_prompt"
    role="dialog"
    style={{ display: props.show ? 'block' : 'none' }}
  >
    <div className="modal-backdrop in" style={{ height: '100%' }} />
    <div className="modal-dialog modal-dialog-coreg">
      <div className="modal-content">
        <div className="modal-body">
          <div className="modal-main-container-coreg">
            <div className="modal-main">
              <div className="modal-title-coreg">
                <div className="logos-coreg">
                  <img alt="cam4 logo" src={cam4Logo} />
                  +
                  <img
                    alt="nakednews logo"
                    src={nakedNewsLogo}
                  />
                </div>
              </div>
              <div className="modal-body-coreg center">
                <div>
                  As an existing CAM4 member, you are eligible
                  for a <strong>'7-Day Free Trial'</strong>.
                  Click the button below to create an account
                  using your CAM4 credentials
                </div>
                <a href="/account/purchase">
                  <button className="btn btn-black btn-coreg">
                    Sign Up Now
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CoRegModal;
